"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.search = search;
exports.searchSuggestions = searchSuggestions;
exports.startSearch = startSearch;
exports.loadCantons = loadCantons;
exports.loadBrunchCantons = loadBrunchCantons;
exports.loadProductionType = loadProductionType;
exports.loadProjects = loadProjects;
exports.loadSoldout = loadSoldout;
exports.loadMembership = loadMembership;
exports.updateSearchFilters = updateSearchFilters;
exports.loadLgwProducts = loadLgwProducts;
exports.loadLgwDeliveryType = loadLgwDeliveryType;
exports.loadProduct = loadProduct;
exports.loadRubrics = loadRubrics;
exports.loadVacation = loadVacation;

var _conf = require("../../conf");

var _advancedFetch = _interopRequireWildcard(require("../advanced-fetch"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function search(queryOptions, loadMore, detailViewSearch, detailViewPath) {
  var meta = {
    loadMore: loadMore,
    search: queryOptions.query,
    activeFilter: queryOptions.filters,
    coordinates: null,
    detailViewSearch: detailViewSearch,
    detailViewPath: detailViewPath,
    time: Date.now()
  };

  if (queryOptions.lon && queryOptions.lat) {
    meta.coordinates = {
      lon: queryOptions.lon,
      lat: queryOptions.lat
    };
  }

  return {
    type: 'search-farms',
    meta: meta,
    payload: (0, _advancedFetch.fetchAndCheckWitHeaders)("".concat(_conf.api.searchUrlTemplate(queryOptions)), {
      credentials: 'include'
    })
  };
}

function searchSuggestions(queryOptions, theme) {
  var meta = {
    search: queryOptions.query,
    time: Date.now(),
    theme: theme
  };
  return {
    type: 'search-suggestions',
    meta: meta,
    payload: (0, _advancedFetch.fetchAndCheckWitHeaders)("".concat(_conf.api.searchSuggestionsUrlTemplate(queryOptions)), {
      credentials: 'include'
    })
  };
}

function startSearch(value) {
  return {
    type: 'search-farms-start',
    search: value
  };
}

function loadCantons(language, query) {
  var isForeign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: 'load-cantons',
    payload: (0, _advancedFetch.default)("".concat(_conf.api.cantonApiUrlTemplate(language, query)), {
      credentials: 'include'
    }),
    meta: {
      language: language,
      isForeign: isForeign
    }
  };
}

function loadBrunchCantons(language, query) {
  return {
    type: 'load-brunch-cantons',
    payload: (0, _advancedFetch.default)("".concat(_conf.api.brunchCantonApiUrlTemplate(language, query)), {
      credentials: 'include'
    })
  };
}

function loadProductionType(language, query) {
  var isForeign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: 'load-productiontype',
    payload: (0, _advancedFetch.default)(_conf.api.productiontypesApiUrlTemplate(language, query), {
      credentials: 'include'
    }),
    meta: {
      language: language,
      isForeign: isForeign
    }
  };
}

function loadProjects(language, query) {
  var isForeign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: 'load-projects',
    payload: (0, _advancedFetch.default)(_conf.api.projectApiUrlTemplate(language, query), {
      credentials: 'include'
    }),
    meta: {
      language: language,
      isForeign: isForeign
    }
  };
}

function loadSoldout(language, query) {
  return {
    type: 'load-soldout',
    payload: (0, _advancedFetch.default)(_conf.api.soldoutApiUrlTemplate(language, query), {
      credentials: 'include'
    })
  };
}

var getProgramsByCase = function getProgramsByCase(language, caseId, query) {
  var programs = [];
  return (0, _advancedFetch.default)(_conf.api.programsByCaseApiUrlTemplate(language, caseId, query), {
    credentials: 'include'
  }).then(function (result) {
    programs = result;
    return [programs];
  });
};

function loadMembership(language, query) {
  var isForeign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: 'load-membership',
    payload: getProgramsByCase(language, 1, query),
    meta: {
      language: language,
      isForeign: isForeign
    }
  };
}

function updateSearchFilters(data) {
  return {
    type: 'update-search-filters',
    data: data
  };
}

function loadLgwProducts(language, query) {
  var isForeign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: 'load-lgw-products',
    payload: (0, _advancedFetch.default)("".concat(_conf.api.lgwProductApiUrlTemplate(language, query)), {
      credentials: 'include'
    }),
    meta: {
      language: language,
      isForeign: isForeign
    }
  };
}

function loadLgwDeliveryType(language, query) {
  var isForeign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: 'load-lgw-delivery-type',
    payload: (0, _advancedFetch.default)("".concat(_conf.api.lgwDeliveryTypeApiUrlTemplate(language, query)), {
      credentials: 'include'
    }),
    meta: {
      language: language,
      isForeign: isForeign
    }
  };
}

function loadProduct(language, query) {
  var isForeign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: 'load-product',
    payload: (0, _advancedFetch.default)("".concat(_conf.api.productsApiUrlTemplate(language, query)), {
      credentials: 'include'
    }),
    meta: {
      language: language,
      isForeign: isForeign
    }
  };
}

function loadRubrics(language, query) {
  var isForeign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: 'load-rubric',
    payload: (0, _advancedFetch.default)("".concat(_conf.api.rubricsApiUrlTemplate(language)), {
      credentials: 'include'
    }),
    meta: {
      language: language,
      isForeign: isForeign
    }
  };
}

function loadVacation(language, query) {
  var isForeign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: 'load-vacation',
    payload: (0, _advancedFetch.default)("".concat(_conf.api.vacationsApiUrlTemplate(language, query)), {
      credentials: 'include'
    }),
    meta: {
      language: language,
      isForeign: isForeign
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./client/components/search/actions.js
// module id = 267
// module chunks = 0